import { HttpErrorResponse } from '@angular/common/http';
import {
    INotesOfAnnualReportDTO,
    INotesTemplateDTO,
    INotesTemplateEntityDTO,
} from '@modeso/types__aumico-lib-notes-be';
import { Action, createAction, createActionGroup, props } from '@ngrx/store';
import { INotesTemplateByLegalFormAndAccountBasisRequest } from '../interfaces/requests/INotesTemplateByLegalFormAndAccountBasisRequest.interface';

export const getNotesTemplates = createAction('[Aumico-Notes-NotesTemplates] getNotesTemplates');

export const onGetNotesTemplatesSuccessfully = createAction(
    '[Aumico-Notes-NotesTemplates] onGetNotesTemplatesSuccessfully',
    props<{ payload: INotesTemplateDTO[] }>(),
);

export const onGetNotesTemplatesFailed = createAction(
    '[Aumico-Notes-NotesTemplates] onGetNotesTemplatesFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const getNotes = createAction(
    `[Aumico-Notes-NotesTemplates] getNotes`,
    props<{ payload: INotesTemplateByLegalFormAndAccountBasisRequest }>(),
);

export const onGetNotesSuccessfully = createAction(
    `[Aumico-Notes-NotesTemplates] onGetNotesSuccessfully`,
    props<{ payload: INotesOfAnnualReportDTO }>(),
);

export const onGetNotesFailed = createAction(
    `[Aumico-Notes-NotesTemplates] onGetNotesFailed`,
    props<{ payload: HttpErrorResponse }>(),
);

export const getNotesTemplateById = createActionGroup({
    source: '[Aumico-Notes-NotesTemplates] getNotesTemplateById',
    events: {
        do: props<{ payload: string }>(),
        success: props<{ payload: INotesTemplateDTO }>(),
        failure: props<{ payload: HttpErrorResponse }>(),
    },
});

export const resetNotes = createAction(`[Aumico-Notes-NotesTemplates] resetNotes`);

export const createNotesTemplate = createAction(
    '[Aumico-Notes-NotesTemplates] createNotesTemplate',
    props<{ payload: INotesTemplateEntityDTO }>(),
);

export const onCreateNotesTemplateSuccessfully = createAction(
    '[Aumico-Notes-NotesTemplates] onCreateNotesTemplateSuccessfully',
    props<{ payload: INotesTemplateDTO }>(),
);

export const onCreateNotesTemplateFailed = createAction(
    '[Aumico-Notes-NotesTemplates] onCreateNotesTemplateFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const updateNotesTemplate = createAction(
    '[Aumico-Notes-NotesTemplates] updateNotesTemplate',
    props<{ payload: INotesTemplateEntityDTO }>(),
);

export const onUpdateNotesTemplateSuccessfully = createAction(
    '[Aumico-Notes-NotesTemplates] onUpdateNotesTemplateSuccessfully',
    props<{ payload: INotesTemplateDTO }>(),
);

export const onUpdateNotesTemplateFailed = createAction(
    '[Aumico-Notes-NotesTemplates] onUpdateNotesTemplateFailed',
    props<{ payload: HttpErrorResponse }>(),
);

export const onSelectNotesTemplate = createAction(
    '[Aumico-Notes-NotesTemplates] onSelectNotesTemplate',
    props<{ payload: string }>(),
);

export interface ActionWithPayload<T> extends Action {
    payload: T;
}
